import React from "react";
import { Link } from "react-router-dom";

// Dedicated Ad Films showcase below the hero. "View All Work" navigates
// in-tab so the browser back button returns to the home page.
export const FeaturedFilms = () => {
  return (
    <section
      id="ad-films"
      data-testid="featured-films-section"
      className="relative bg-black overflow-hidden border-t border-white/5"
    >
      <div className="relative min-h-[75vh] sm:min-h-[85vh] w-full overflow-hidden flex items-end">
        {/* Static placeholder banner until the showreel cut is uploaded.
            Uses a cinematic crew shot distinct from the home hero. */}
        <img
          src="https://images.pexels.com/photos/2873486/pexels-photo-2873486.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1600&w=2400"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="featured-films-bg"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black" />
        <div className="absolute inset-0 bg-black/20" />

        {/* Lower content */}
        <div className="relative z-10 w-full pb-14 sm:pb-20 px-6 sm:px-10 lg:px-14">
          <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-end">
            <div className="md:col-span-8">
              <h2 className="font-serif text-white text-6xl sm:text-8xl lg:text-[10rem] font-light tracking-tighter leading-[0.85]">
                Ad <em className="italic font-medium">Films</em>
                <span className="font-light">.</span>
              </h2>
              <p className="hidden md:block mt-6 sm:mt-8 max-w-xl text-white/80 text-base sm:text-lg font-light leading-relaxed">
                Where a full-fledge crew shows up: director, DOP, gaffer,
                grip, art, sound, edit. The complete pipeline, captured frame
                by frame, lit shadow by shadow.
              </p>
            </div>

            <div className="md:col-span-4 md:justify-self-end flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link
                to="/films"
                data-testid="featured-films-cta"
                className="group inline-flex items-center gap-4 bg-white text-black hover:bg-white/85 px-6 py-4 text-[11px] tracking-[0.3em] uppercase transition-colors"
              >
                <span>Watch the Films</span>
                <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">
                  →
                </span>
              </Link>
              <a
                href="#contact"
                data-testid="featured-films-brief"
                className="group inline-flex items-center gap-4 border border-white/40 hover:border-white text-white px-6 py-4 text-[11px] tracking-[0.3em] uppercase transition-colors"
              >
                <span>Send a Brief</span>
              </a>
            </div>
          </div>
        </div>

        {/* Crew strip */}
        <div className="absolute bottom-3 left-6 sm:left-10 right-6 sm:right-10 hidden md:flex items-center gap-6 text-[10px] tracking-[0.3em] uppercase text-white/30 font-mono overflow-hidden">
          <span>Director</span>
          <span className="opacity-50">·</span>
          <span>DOP</span>
          <span className="opacity-50">·</span>
          <span>Gaffer</span>
          <span className="opacity-50">·</span>
          <span>Grip</span>
          <span className="opacity-50">·</span>
          <span>Art</span>
          <span className="opacity-50">·</span>
          <span>Sound</span>
          <span className="opacity-50">·</span>
          <span>Edit</span>
          <span className="opacity-50">·</span>
          <span>Colour</span>
        </div>
      </div>
    </section>
  );
};

export default FeaturedFilms;
